import { render } from "./dashboard.vue?vue&type=template&id=60b670a0&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=60b670a0&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b670a0"]])

export default __exports__